import { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import '../TableauObs/Summary/Summary.scss';
import '../DataEstate/data-estate.scss';
import { getIncidentDetails, incidentSearchForJobExecutions, getDatabricksClusterImpactDetails, fetchChartData, getTeradataJobExecutions, fetchJobPerformance } from '../../service/service';
import { Column } from 'react-data-grid';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CustomizedDataGrid } from '../customized_data_grid';
import Loader from '../Loader/loader';
import moment from 'moment';
import DateRangeFilter from 'components/Dropdown/DateRangeFilter';
import StatusChip from 'components/Table/StatusChip';
import RowTypography from 'components/Table/RowTypography';
import CustomDropdown from 'components/Dropdown';
import BarChartWidget from 'components/Widgets/BarChartWidget';
import IncidentIcon from '../../assets/Incident Impact Analysis.svg';
import PageHeader from 'components/Header/Page';

interface Row {
	id: string;
	scheduledJob: string;
	sector: string;
	system: string;
	process: string;
	projects: string;
	jobStatus: string;
	startTime: string;
	endTime: string;
	slaEndTime: string;
	slaStatus: string;
	actualStartTime: string;
	normalCompletionTime: string;
	actualCompletionTime: string;
	currentExecutionTime: string;
	averageExecutionTime: string;
	reason: string;
	followUp: string;
	actionTaken: string;
	lastSuccessfulRun: string;
	estimatedDuration: string;
	executionFrequency: string;
	criticalFlag: string;
	date: string;
	jobName: string;
	name: string;
	runStatus: string;
	reasonForDelay: string;
	runStartTime: string;
	runEndTime: string;
	clusterName: string;
	driverNodeType: string;
	errorMessage: string;
	timestamp: string;
	projectCode: string;
	projectNumber: string;
	projectName: string;
	sparkVersion: string;
	workspaceName: string;
	clusterId: string;
	jobId: string;
	runName: string;
	status: string;
	time: string;
	nodeType: string;
	dfProjectCode: string;
	dfDataAssetName: string;
	iterationDate: string;
	cyclic: boolean;
	pipelineName: string;
	runStart: string;
	runEnd: string;
	duration: string;
	triggeredBy: string;
	error: string;
	run: string;
	parameters: string;
	annotations: string;
	runId: string;
	startDate: string;
	workspaceId: string;
	businessSector: string;
	environment: string;
	supportContact: string;
	serviceName: string;
	billingInformation: string;
	orgGrpCodeProjectCode: string;
	dfSectorName: string;
	businessContact: string;
	statementId: string;
	warehouseID: string;
}

export default function IncidentImpactAnalysis() {
	const [grafanaChartLoading, setGrafanaChartLoading] = useState(true);
	const [, setGrafanaChartOptions] = useState<any>();
	const [performanceByDay, setPerformanceByDay] = useState<any>(false);
	const location = useLocation();
	const paramsData = location.state;
	const [searchParams, setSearchParams] = useSearchParams();
	const hasDrillDowned = searchParams.has('isDrillDowned');
	const minJobExecDate = '2023-03-01';
	const [dateTimeRange, setDateTimeRange] = useState<any>(
		[
			paramsData?.openedDate ? moment(paramsData.openedDate).subtract(1, 'days')
				: moment().startOf('day').subtract(1, 'hours'),
			paramsData?.resolvedDate
				? moment(paramsData.resolvedDate).add(2, 'days')
				: moment().endOf('day').subtract(1, 'hours')
		]
	);
	const [databrickIncident] = useState<any>(paramsData.incidentId == 'INC09974786' || paramsData.incidentId == 'INC10192559' ? 'Databricks' :
		paramsData?.assignmentGroup == 'ADVANCED ANALYTICS PLATFORM SUPPORT' && paramsData.configurationItem != 'RETAIL360-AKS CLUSTER PROD' || paramsData.incidentId == 'INC10974136' ? 'ADB' :
			paramsData?.assignmentGroup == 'ADVANCED ANALYTICS PLATFORM SUPPORT' && paramsData.configurationItem == 'RETAIL360-AKS CLUSTER PROD' ? 'R360' : 'false')
	const [execution, setExecution] = useState(false)
	const [, setExecutionTitle] = useState(`Projects Performance Details as on ${moment(dateTimeRange[0]).format('YYYY-MM-DD')}`)
	const [, setToggleTitle] = useState('By Project')
	const [performanceTitle, setPerformanceTitle] = useState('Projects Performance')
	moment.updateLocale(moment.locale(), { invalidDate: '' });
	const [incidentType, setIncidentType] = useState<any>(paramsData?.assignmentGroup == 'ADVANCED ANALYTICS PLATFORM SUPPORT' || paramsData?.incidentId == 'INC09974786' || paramsData?.incidentId == 'INC10974136' ? 'databricks' : 'teradata');
	let dateArray: any[] = [];
	const [dateRange, setDateRange] = useState<any>();
	function getDatabricksColumns(): Array<Column<Row>> {
		return [
			...(databrickIncident == 'false' ? [
				{
					key: 'date',
					name: 'Date',
					width: 180,
					minWidth: 180,
					formatter(props: { row: { date: string; }; }) {
						const data = props.row.date ? moment(props.row.date).utc().format('YYYY-MM-DD') : '-';
						return data;
					},
				},
				{
					key: 'time',
					name: 'Time',
					width: 180,
					minWidth: 180,
					formatter(props: { row: { time: string; }; }) {
						const data = props.row.time ? moment(props.row.time).utc().format('hh:mm:ss') : '-';
						return data;
					},
				},
				{
					key: 'workspaceName',
					name: 'Workspace Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { workspaceName: string; }; }) {
						const data = props.row.workspaceName ? props.row.workspaceName : '-';
						return data;
					}
				},
				{
					key: 'clusterId',
					name: 'Cluster ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { clusterId: string; }; }) {
						const data = props.row.clusterId ? props.row.clusterId : '-';
						return data;
					}
				},
				{
					key: 'clusterName',
					name: 'Cluster Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { clusterName: string; }; }) {
						const data = props.row.clusterName ? props.row.clusterName : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'status',
					name: 'Status',
					width: 130,
					minWidth: 130,
					cellClass: 'center-text',
					formatter(props: { row: { status: string; }; }) {
						const status = props.row.status;
						return <StatusChip status={status == null ? 'N/A' : status} />
					}
				},
				{
					key: 'sparkVersion',
					name: 'Spark Version',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { sparkVersion: string; }; }) {
						const data = props.row.sparkVersion ? props.row.sparkVersion : '-';
						return data;
					}
				},
				{
					key: 'driverNodeType',
					name: 'Driver Node Type',
					minWidth: 150,
					width: 180,
					formatter(props: { row: { driverNodeType: string; }; }) {
						const data = props.row.driverNodeType ? props.row.driverNodeType : '-';
						return data;
					}
				},
				{
					key: 'nodeType',
					name: 'Node Type',
					minWidth: 150,
					width: 180,
					formatter(props: { row: { nodeType: string; }; }) {
						const data = props.row.nodeType ? props.row.nodeType : '-';
						return data;
					}
				},

				{
					key: 'jobId',
					name: 'Job ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { jobId: string; }; }) {
						const data = props.row.jobId ? props.row.jobId : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'runName',
					name: 'Run Name',
					width: 200,
					minWidth: 250,
					formatter(props: { row: { runName: string; }; }) {
						const data = props.row.runName ? props.row.runName.replaceAll('?', '') : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'errorMessage',
					name: 'Error Message',
					width: 230,
					minWidth: 200,
					formatter(props: { row: { errorMessage: string; }; }) {
						const data = props.row.errorMessage ? props.row.errorMessage : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'sector',
					name: 'Sector',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { sector: string; }; }) {
						const data = props.row.sector ? props.row.sector : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'projectCode',
					name: 'Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectCode: string; }; }) {
						const data = props.row.projectCode ? props.row.projectCode : '-';
						return data;
					}
				},
				{
					key: 'projectNumber',
					name: 'Project Number',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectNumber: string; }; }) {
						const data = props.row.projectNumber ? props.row.projectNumber : '-';
						return data;
					}
				},
				{
					key: 'projectName',
					name: 'Project Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectName: string; }; }) {
						const data = props.row.projectName ? props.row.projectName : '-';
						return data;
					}
				},
				{
					key: 'dfProjectCode',
					name: 'DF Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfProjectCode: string; }; }) {
						const data = props.row.dfProjectCode ? props.row.dfProjectCode : '-';
						return data;
					}
				},
				{
					key: 'dfDataAssetName',
					name: 'DF Data Asset Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfDataAssetName: string; }; }) {
						const data = props.row.dfDataAssetName ? props.row.dfDataAssetName : '-';
						return data;
					}
				}] : []),
			...(databrickIncident == 'Databricks' ? [
				{
					key: 'pipelineName',
					name: 'Pipeline Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { pipelineName: string; }; }) {
						const data = props.row.pipelineName ? props.row.pipelineName : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'runStart',
					name: 'Run Start',
					// minWidth: 150,
					// width: 200,
					formatter(props: { row: { runStart: string; }; }) {
						const runStart = props.row.runStart;
						if (runStart) {
							return moment.utc(runStart).format('MM-DD-YY HH:mm:ss');
						}
						return '';
					}
				},
				{
					key: 'runEnd',
					name: 'Run End',
					formatter(props: { row: { runEnd: string; }; }) {
						const endDate = props.row.runEnd;
						if (endDate) {
							return moment.utc(endDate).format('MM-DD-YY HH:mm:ss');
						}
						return '';
					}
				},
				{
					key: 'duration',
					name: 'Duration',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { duration: string; }; }) {
						const data = props.row.duration ? props.row.duration : '-';
						return data;
					}
				},
				{
					key: 'triggeredBy',
					name: 'Triggered By',
					minWidth: 250,
					width: 250,
					formatter(props: { row: { triggeredBy: string; }; }) {
						const data = props.row.triggeredBy ? props.row.triggeredBy : '-';
						return data;
					}
				},
				{
					key: 'status',
					name: 'Status',
					width: 150,
					minWidth: 150,
					cellClass: 'center-text',
					formatter(props: { row: { status: string; }; }) {
						const status = props.row.status && props.row.status == 'Succeeded' ? 'Successful' : props.row.status && props.row.status == 'Failed' ? 'Failure' : '';
						return <StatusChip status={status} />
					}
				},
				{
					key: 'run',
					name: 'Run',
					width: 200,
					minWidth: 250,
					formatter(props: { row: { run: string; }; }) {
						const data = props.row.run ? props.row.run.replaceAll('?', '') : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'runId',
					name: 'Run ID',
					formatter(props: { row: { runId: string; }; }) {
						const data = props.row.runId ? props.row.runId : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				}] : []),
			...(databrickIncident == 'ADB' ? [
				{
					key: 'startDate',
					name: 'Start Date',
					width: 180,
					minWidth: 180,
					formatter(props: { row: { startDate: string; }; }) {
						const data = props.row.startDate ? moment(props.row.startDate).utc().format('YYYY-MM-DD') : '-';
						return data;
					},
				},
				{
					key: 'workspaceId',
					name: 'Workspace ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { workspaceId: string; }; }) {
						const data = props.row.workspaceId && props.row.workspaceId !== 'null' ? props.row.workspaceId : '-';
						return data;
					}
				},
				{
					key: 'workspaceName',
					name: 'Workspace Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { workspaceName: string; }; }) {
						const data = props.row.workspaceName && props.row.workspaceName !== 'null' ? props.row.workspaceName : '-';
						return data;
					}
				},
				{
					key: 'clusterId',
					name: 'Cluster ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { clusterId: string; }; }) {
						const data = props.row.clusterId && props.row.clusterId !== 'null' ? props.row.clusterId : '-';
						return data;
					}
				},
				{
					key: 'jobId',
					name: 'Job ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { jobId: string; }; }) {
						const data = props.row.jobId && props.row.jobId !== 'null' ? props.row.jobId : '-';
						return data;
					}
				},
				{
					key: 'businessSector',
					name: 'Business Sector',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { businessSector: string; }; }) {
						const data = props.row.businessSector && props.row.businessSector !== 'null' ? props.row.businessSector : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'environment',
					name: 'Environment',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { environment: string; }; }) {
						const data = props.row.environment && props.row.environment !== 'null' ? props.row.environment : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'supportContact',
					name: 'Support Contact',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { supportContact: string; }; }) {
						const data = props.row.supportContact && props.row.supportContact !== 'null' ? props.row.supportContact : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'dfDataAssetName',
					name: 'DF Data Asset Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfDataAssetName: string; }; }) {
						const data = props.row.dfDataAssetName && props.row.dfDataAssetName !== 'null' ? props.row.dfDataAssetName : '-';
						return data;
					}
				},
				{
					key: 'serviceName',
					name: 'Service Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { serviceName: string; }; }) {
						const data = props.row.serviceName && props.row.serviceName !== 'null' ? props.row.serviceName : '-';
						return data;
					}
				},
				{
					key: 'billingInformation',
					name: 'Billing Information',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { billingInformation: string; }; }) {
						const data = props.row.billingInformation && props.row.billingInformation !== 'null' ? props.row.billingInformation : '-';
						return data;
					}
				},
				{
					key: 'orgGrpCodeProjectCode',
					name: 'Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { orgGrpCodeProjectCode: string; }; }) {
						const data = props.row.orgGrpCodeProjectCode && props.row.orgGrpCodeProjectCode !== 'null' ? props.row.orgGrpCodeProjectCode : '-';
						return data;
					}
				},
				{
					key: 'dfProjectCode',
					name: 'DF Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfProjectCode: string; }; }) {
						const data = props.row.dfProjectCode && props.row.dfProjectCode !== 'null' ? props.row.dfProjectCode : '-';
						return data;
					}
				},
				{
					key: 'dfSectorName',
					name: 'DF Sector Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfSectorName: string; }; }) {
						const data = props.row.dfSectorName && props.row.dfSectorName !== 'null' ? props.row.dfSectorName : '-';
						return data;
					}
				},
				{
					key: 'businessContact',
					name: 'Business Contact',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { businessContact: string; }; }) {
						const data = props.row.businessContact && props.row.businessContact !== 'null' ? props.row.businessContact : '-';
						return data;
					}
				},
				{
					key: 'projectName',
					name: 'Project Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectName: string; }; }) {
						const data = props.row.projectName && props.row.projectName !== 'null' ? props.row.projectName : '-';
						return data;
					}
				},
				{
					key: 'projectNumber',
					name: 'Project Number',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectNumber: string; }; }) {
						const data = props.row.projectNumber && props.row.projectNumber !== 'null' ? props.row.projectNumber : '-';
						return data;
					}
				},
				{
					key: 'runName',
					name: 'Run Name',
					width: 200,
					minWidth: 250,
					formatter(props: { row: { runName: string; }; }) {
						const data = props.row.runName && props.row.runName !== 'null' ? props.row.runName.replaceAll('?', '') : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'status',
					name: 'Status',
					width: 130,
					minWidth: 130,
					cellClass: 'center-text',
					formatter(props: { row: { status: string; }; }) {
						const status = props.row.status;
						return <StatusChip status={status == null ? 'N/A' : status} />
					}
				},
				{
					key: 'errorMessage',
					name: 'Error Message',
					width: 230,
					minWidth: 200,
					formatter(props: { row: { errorMessage: string; }; }) {
						const data = props.row.errorMessage && props.row.errorMessage !== 'null' ? props.row.errorMessage : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
			] : []),
			...(databrickIncident == 'R360' ? [
				{
					key: 'startDate',
					name: 'Start Date',
					width: 180,
					minWidth: 180,
					formatter(props: { row: { startDate: string; }; }) {
						const data = props.row.startDate ? moment(props.row.startDate).utc().format('YYYY-MM-DD') : '-';
						return data;
					},
				},
				{
					key: 'workspaceId',
					name: 'Workspace ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { workspaceId: string; }; }) {
						const data = props.row.workspaceId && props.row.workspaceId !== 'null' ? props.row.workspaceId : '-';
						return data;
					}
				},
				{
					key: 'workspaceName',
					name: 'Workspace Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { workspaceName: string; }; }) {
						const data = props.row.workspaceName && props.row.workspaceName !== 'null' ? props.row.workspaceName : '-';
						return data;
					}
				},
				{
					key: 'warehouseID',
					name: 'Warehouse ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { warehouseID: string; }; }) {
						const data = props.row.warehouseID && props.row.warehouseID !== 'null' ? props.row.warehouseID : '-';
						return data;
					}
				},
				{
					key: 'statementId',
					name: 'Statement ID',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { statementId: string; }; }) {
						const data = props.row.statementId && props.row.statementId !== 'null' ? props.row.statementId : '-';
						return data;
					}
				},
				{
					key: 'businessSector',
					name: 'Business Sector',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { businessSector: string; }; }) {
						const data = props.row.businessSector && props.row.businessSector !== 'null' ? props.row.businessSector : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'environment',
					name: 'Environment',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { environment: string; }; }) {
						return <RowTypography>{'Prod'}</RowTypography>;
					}
				},
				{
					key: 'supportContact',
					name: 'Support Contact',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { supportContact: string; }; }) {
						const data = props.row.supportContact && props.row.supportContact !== 'null' ? props.row.supportContact : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'dfDataAssetName',
					name: 'DF Data Asset Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfDataAssetName: string; }; }) {
						const data = props.row.dfDataAssetName && props.row.dfDataAssetName !== 'null' ? props.row.dfDataAssetName : '-';
						return data;
					}
				},
				{
					key: 'serviceName',
					name: 'Service Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { serviceName: string; }; }) {
						const data = props.row.serviceName && props.row.serviceName !== 'null' ? props.row.serviceName : '-';
						return data;
					}
				},
				{
					key: 'billingInformation',
					name: 'Billing Information',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { billingInformation: string; }; }) {
						const data = props.row.billingInformation && props.row.billingInformation !== 'null' ? props.row.billingInformation : '-';
						return data;
					}
				},
				{
					key: 'orgGrpCodeProjectCode',
					name: 'Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { orgGrpCodeProjectCode: string; }; }) {
						const data = props.row.orgGrpCodeProjectCode && props.row.orgGrpCodeProjectCode !== 'null' ? props.row.orgGrpCodeProjectCode : '-';
						return data;
					}
				},
				{
					key: 'dfProjectCode',
					name: 'DF Project Code',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfProjectCode: string; }; }) {
						const data = props.row.dfProjectCode && props.row.dfProjectCode !== 'null' ? props.row.dfProjectCode : '-';
						return data;
					}
				},
				{
					key: 'dfSectorName',
					name: 'DF Sector Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { dfSectorName: string; }; }) {
						const data = props.row.dfSectorName && props.row.dfSectorName !== 'null' ? props.row.dfSectorName : '-';
						return data;
					}
				},
				{
					key: 'businessContact',
					name: 'Business Contact',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { businessContact: string; }; }) {
						const data = props.row.businessContact && props.row.businessContact !== 'null' ? props.row.businessContact : '-';
						return data;
					}
				},
				{
					key: 'projectName',
					name: 'Project Name',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectName: string; }; }) {
						const data = props.row.projectName && props.row.projectName !== 'null' ? props.row.projectName : '-';
						return data;
					}
				},
				{
					key: 'projectNumber',
					name: 'Project Number',
					minWidth: 200,
					width: 200,
					formatter(props: { row: { projectNumber: string; }; }) {
						const data = props.row.projectNumber && props.row.projectNumber !== 'null' ? props.row.projectNumber : '-';
						return data;
					}
				},
				{
					key: 'runName',
					name: 'Run Name',
					width: 200,
					minWidth: 250,
					formatter(props: { row: { runName: string; }; }) {
						const data = props.row.runName && props.row.runName !== 'null' ? props.row.runName.replaceAll('?', '') : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
				{
					key: 'status',
					name: 'Status',
					width: 130,
					minWidth: 130,
					cellClass: 'center-text',
					formatter(props: { row: { status: string; }; }) {
						const status = props.row.status;
						return <StatusChip status={status == null ? 'N/A' : status} />
					}
				},
				{
					key: 'errorMessage',
					name: 'Error Message',
					width: 230,
					minWidth: 200,
					formatter(props: { row: { errorMessage: string; }; }) {
						const data = props.row.errorMessage && props.row.errorMessage !== 'null' ? props.row.errorMessage : '-';
						return <RowTypography>{data}</RowTypography>;
					}
				},
			] : [])
		]
	}

	function getColumns(): Array<Column<Row>> {
		return [
			{
				key: 'name',
				name: 'Job Name(s)',
				minWidth: 250,
				width: 250,
				formatter(props) {
					const data = props.row.name ? props.row.name : '-';
					return <RowTypography>{data}</RowTypography>
				}
			},
			{
				key: 'sector',
				name: 'Sector',
				width: 200,
				minWidth: 200,
				formatter(props) {
					const data = props.row.sector ? props.row.sector : '-';
					return <RowTypography>{data}</RowTypography>
				}
			},
			{
				key: 'system',
				name: 'System',
				width: 200,
				minWidth: 200,
				formatter(props) {
					const data = props.row.system ? props.row.system : '-';
					return <RowTypography>{data}</RowTypography>
				}
			},
			{
				key: 'process',
				name: 'Project',
				formatter(props) {
					const data = props.row.process ? props.row.process.replaceAll('?', '') : '-';
					return <RowTypography>{data}</RowTypography>
				}
			},
			{
				key: 'slaStatus',
				name: 'SLA Status',
				width: 200,
				minWidth: 200,
				cellClass: 'center-text',
				formatter(props) {
					const status = props.row.slaStatus;
					return <StatusChip status={status == null ? 'Scheduled' : status === 'Met' ? 'Sla Met' : status === 'Not Met' ? 'Sla Missed' : status} />;
				}
			},
			{
				key: 'runStatus',
				name: 'Job Status',
				cellClass: 'center-text',
				formatter(props) {
					const status = props.row.runStatus;
					return <StatusChip status={status == null ? '' : status} />;
				}
			},
			{
				key: 'runEndTime',
				name: 'Act. End Time (CST)',
				formatter(props) {
					const endDate = props.row.runEndTime;
					if (endDate) {
						return moment.utc(endDate).format('HH:mm');
					}
					return '';
				}
			},
			{
				key: 'slaEndTime',
				name: 'SLA Time (CST)',
				formatter(props) {
					const data = props.row.cyclic == true ? 'Continuously running job' : props.row.slaEndTime.split(':').slice(0, 2).join(':');
					return (
						<RowTypography> {data}
						</RowTypography>
					);
				}
			},
			...(execution ? [{
				key: 'reasonForDelay',
				name: 'Reason',
				width: 230,
				minWidth: 200,
				formatter(props: { row: { reasonForDelay: any; }; }) {
					const data = props.row.reasonForDelay ? props.row.reasonForDelay : '-';
					return <RowTypography>{data}</RowTypography>
				}
			}] : []),
		];
	}

	const [incidentDetails, setIncidentDetails] = useState<Row[]>([]);
	const [slaReport, setSlaReport] = useState([]);
	const [loading, setLoading] = useState(false);
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);

	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [filterData, setFilterData] = useState<Row[]>([]);
	const [filterInfo, setFilterInfo] = useState([]);
	const [searchDetails, setFilterSearchInfo] = useState([]);

	const defaultDatabricksColumnNames = [
		...databrickIncident == 'false' ? ['Date',
			'Time',
			'Workspace Name',
			'Cluster ID',
			'Cluster Name',
			'Status',
			'Spark Version',
			'Driver Node Type',
			'Node Type',
			'Job ID',
			'Run Name',
			'Error Message',
			'Sector',
			'Project Code',
			'Project Number',
			'Project Name',
			'DF Project Code',
			'DF Data Asset Name',
			'Workspace ID',
			'DBR Version'] : [],
		...databrickIncident == 'Databricks' ? [
			'Pipeline Name',
			'Run Start',
			'Run End',
			'Duration',
			'Triggered By',
			'Status',
			'Run',
			'Run ID'] : [],
		...databrickIncident == 'ADB' ? [
			'Start Date',
			'Workspace ID',
			'Workspace Name',
			'Cluster ID',
			'Job ID',
			'Business Sector',
			'Environment',
			'Support Contact',
			'DF Data Asset Name',
			'Service Name',
			'Billing Information',
			'Project Code',
			'DF Project Code',
			'DF Sector Name',
			'Business Contact',
			'Project Name',
			'Project Number',
			'Run Name',
			'Status',
			'Error Message'] : [],
		...databrickIncident == 'R360' ? [
			'Start Date',
			'Workspace ID',
			'Workspace Name',
			'Statement ID',
			'Warehouse ID',
			'Business Sector',
			'Environment',
			'Support Contact',
			'DF Data Asset Name',
			'Service Name',
			'Billing Information',
			'Project Code',
			'DF Project Code',
			'DF Sector Name',
			'Business Contact',
			'Project Name',
			'Project Number',
			'Run Name',
			'Status',
			'Error Message'] : [],
	];
	const defaultColumnNames = [
		'Job Name',
		'Sector',
		'System',
		'Projects',
		'SLA Status',
		'Job Status',
		'Act. Start Time (CST)',
		'Act. End Time (CST)',
		'SLA Time (CST)',
		'Reason',
	];
	const defaultColumnNamesProject = [

		'Sector',
		'System',
		'Project',
		'SLA Status',
		'Act. End Time (CST)',
		'SLA Time (CST)',
		'Job Status',
		'Job Name(s)',
	];


	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		fetchIncidentsDetailFunc(value, pageSize, sortingInfo, dateTimeRange[0], dateTimeRange[1], parseFilter(filterInfo), execution);
	};

	const handlepageSizeChange = (event: any) => {
		fetchIncidentsDetailFunc('1', event.target.value, sortingInfo, dateTimeRange[0], dateTimeRange[1], parseFilter(filterInfo), execution);
	};
	const handleSorting = (sortingInfo: any) => {
		fetchIncidentsDetailFunc(page, pageSize, sortingInfo, dateTimeRange[0], dateTimeRange[1], parseFilter(filterInfo), execution);
	};

	const handleFilter = (filterInfo: any) => {
		resetSearchParams();
		setFilterInfo(filterInfo);
		fetchIncidentsDetailFunc(1, pageSize, sortingInfo, dateTimeRange[0], dateTimeRange[1], parseFilter(filterInfo), execution);
	};
	//commen
	const handleSearch = (searchDetails: any, columnKey: any) => {
		incidentSearchFunc(searchDetails, parseFilter(filterInfo, 'scheduledJob'));
	};

	let incident = ['ADVANCED ANALYTICS PLATFORM SUPPORT', 'INFRA AZURE CLOUD']

	const parseFilter = (filterInfo: any, name?: string) => {
		// Call only filterable columns and reset the filtering in case of wrong/empty column
		const parsedFilter: any = {};
		Object.keys(filterInfo).forEach((key: any) => {
			if (key !== name && filterInfo[key] && filterInfo[key].length) {
				parsedFilter[key] = filterInfo[key];
			}
		});
		return parsedFilter;
	};

	// [Date Range Menu]
	const handleDateTimeChange = ([from, to]: any) => {
		setDateTimeRange([from, to]);
	};
	const applyDateTimeRange = ([fromDate, toDate]: any) => {
		resetSearchParams();
		fetchIncidentsDetailFunc(page, pageSize, sortingInfo, fromDate, toDate, parseFilter(filterInfo), execution);
	};

	const resetSearchParams = () => {
		if (hasDrillDowned || searchParams.has('fromDate') || searchParams.has('toDate')) {
			searchParams.delete('status');
			searchParams.delete('scheduleDate');
			searchParams.delete('isDrillDowned');
			searchParams.delete('fromDate');
			searchParams.delete('toDate');
			setSearchParams(searchParams);
		}
	};

	async function fetchSlaReportData(fromDateTime: any, toDateTime: any) {
		setLoading(true);
		let fromDate = moment(fromDateTime).format('YYYY-MM-DD')
		let toDate = moment(toDateTime).format('YYYY-MM-DD')
		if (incidentType == 'teradata') {
			let type = execution ? 1 : 2
			let res = await fetchJobPerformance(fromDate, toDate, type, 'teradata');
			setSlaReport(res.data)
			incidentChartTeraData(res.data)
			res.data?.forEach((res: any, i: number) => {
				const key = Object.keys(res)[0];
				dateArray.push(key);
			});
			fetchIncidentsDetailFunc(page, pageSize, sortingInfo, dateArray[0], dateTimeRange[1], parseFilter(filterInfo), true);
		} else if (incidentType == 'databricks') {
			let type = databrickIncident == 'false' ? 'Databricks' : databrickIncident
			let res = await fetchJobPerformance(fromDate, toDate, 0, type);
			setSlaReport(res.data)
			incidentChartTeraData(res.data)
			res.data?.forEach((res: any, i: number) => {
				const key = Object.keys(res)[0];
				dateArray.push(key);
			});
			fetchIncidentsDetailFunc(page, pageSize, sortingInfo, dateArray[0], dateTimeRange[1], parseFilter(filterInfo), true);
		}
	}

	async function fetchIncidentsDetailFunc(pageNumber: any,
		size: any,
		sortingInfo: any,
		fromDateTime: any,
		toDateTime: any,
		jobFilterInfo: any,
		pageOnLoad?: boolean,
		execution?: any) {
		setLoading(true);
		let isExecution = ''
		if (execution)
			isExecution = 'job';
		else
			isExecution = 'project'

		setDateTimeRange([fromDateTime, toDateTime]);
		let fromDate = moment.utc(fromDateTime).format('YYYY-MM-DD')
		let toDate = moment.utc(toDateTime).format('YYYY-MM-DD')
		let incidentType = 'teradata'
		let incidentId = paramsData?.incidentId
		if (paramsData?.assignmentGroup == 'ADVANCED ANALYTICS PLATFORM SUPPORT' || paramsData?.incidentId == 'INC09974786' || paramsData?.incidentId == 'INC10974136') {
			incidentType = 'databricks'
		}
		setIncidentType(incidentType);
		let res
		if (incidentType == 'teradata') {
			res = await getTeradataJobExecutions({
				page: pageNumber.toString(),
				size: size.toString(),
				sortingInfo,
				filterInfo: jobFilterInfo,
				fromDateTime: fromDate,
				toDateTime: toDate,
				isDataestate: true,
				execution: isExecution
			});
		} else if (incidentType == 'databricks') {
			let databrickType = ''
			let mimType = ''
			if (databrickIncident == 'Databricks' && paramsData.incidentId != 'INC10974136' && paramsData.incidentId != 'INC11223786')
				databrickType = 'new'
			else if (databrickIncident == 'ADB' || databrickIncident == 'R360') {
				databrickType = 'newInc'
				mimType = databrickIncident
			}
			else
				databrickType = 'old'

			res = await getDatabricksClusterImpactDetails({
				page: pageNumber.toString(),
				size: size.toString(),
				sortingInfo,
				filterInfo: jobFilterInfo,
				fromDateTime: fromDate,
				toDateTime: toDate,
				incidentId,
				databrickIncident: databrickType,
				mimType
			});
			databricksExecution(res, pageNumber, size, sortingInfo, jobFilterInfo)
		} else {
			res = await getIncidentDetails(
				pageNumber.toString(),
				size.toString(),
				sortingInfo,
				jobFilterInfo,
				fromDate,
				toDate,
				incidentType);
		}

		let slaData;
		if (incident.includes(paramsData.incidentId)) {
			let sla = {
				startDate: fromDateTime,
				endDate: toDateTime,
				incidentId: paramsData.incidentId
			}
			slaData = await fetchChartData(sla)
		}


		if (incidentType !== 'databricks' && res.success) {
			setIncidentDetails(res.data.jobs);
			setPaginationData(res.data.page);
			const filters = res.data.filterOptions;
			let formatedDates: any = [];
			Object.entries(filters).filter((d: any) => {
				if (d[0] == 'iterationDate') {
					formatedDates = d[1].map((s: any) => moment(s).utc().format('YYYY-MM-DD'))
				}
			});
			filters['iterationDate'] = sortingInfo.sortBy == 'iterationDate' && sortingInfo.sortDir == 'desc' ? formatedDates.reverse() : formatedDates
			setFilterData(filters);
			setPage(pageNumber);
			setPageSize(res.data.page.totalElements);
			setSortingInfo(sortingInfo);
			setFilterInfo(jobFilterInfo);
			setLoading(false);
			const jobExecutionsState = {
				page: res.data.page,
				filterOptions: res.data.filterOptions,
				pageSize: size,
				pageNumber,
				sortingInfo,
				filterInfo: jobFilterInfo
			};
			localStorage.setItem('jobExecutionsState', JSON.stringify(jobExecutionsState));
		}

		setLoading(false);
	}

	// Generate the dates between startDate and endDate
	function getDatesInRange(startDate: any, endDate: any) {
		let start = moment(startDate).startOf('day').toDate();
		let end = moment(endDate).startOf('day').toDate();
		const dates = [];
		while (start <= end) {
			dates.push(new Date(start));
			start.setDate(start.getDate() + 1);
		}

		return dates;
	}
	const databricksExecution = (res: any, pageNumber: any, size: any, sortingInfo: any, jobFilterInfo: any) => {
		if (res.success && res.data.data) {
			setIncidentDetails(res.data.data);
			setPaginationData(res.data.page);
			const filters = res.data.filterOptions;
			let formatedDates: any = [];
			Object.entries(filters).filter((d: any) => {
				if (d[0] == 'date') {
					formatedDates = d[1].map((s: any) => moment(s).utc().format('YYYY-MM-DD'))
				}
			});
			filters['date'] = formatedDates
			setFilterData(filters);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
			setLoading(false);
			const jobExecutionsState = {
				page: res.data.page,
				filterOptions: res.data.filterOptions,
				pageSize: size,
				pageNumber,
				sortingInfo,
			};
			localStorage.setItem('jobExecutionsState', JSON.stringify(jobExecutionsState));
		}
		setLoading(false);
	};

	async function incidentSearchFunc(searchDetails: any, jobFilterInfo: any) {
		const res = await incidentSearchForJobExecutions(searchDetails, jobFilterInfo);
		if (res.success) {
			setFilterSearchInfo(res.data);
		}
	}

	const handleSlaReportOnclick = (param: any) => {
		if (param && param.name) {
			fetchIncidentsDetailFunc(page, pageSize, sortingInfo, param.name, dateTimeRange[1], parseFilter(filterInfo), true);
		}
	};

	const incidentChartTeraData = (reportData: any) => {
		const startDate = paramsData?.outageStartTime ? moment(paramsData.outageStartTime).subtract(1, 'days') : paramsData?.openedDate ? moment(paramsData.openedDate).subtract(1, 'days')
			: moment().startOf('day').subtract(1, 'hours');
		const endDate = paramsData?.outageEndTime
			? moment(paramsData.outageEndTime).add(2, 'days').isSameOrAfter(moment().startOf("day"))
				? moment().startOf("day")
				: moment(paramsData.outageEndTime).add(2, 'days')
			: paramsData?.resolvedDate
				? moment(paramsData.resolvedDate).add(2, 'days').isSameOrAfter(moment().startOf("day"))
					? moment().startOf("day")
					: moment(paramsData.resolvedDate).add(2, 'days')
				: moment().endOf('day').subtract(1, 'hours');
		const duration = moment.duration(endDate.diff(startDate));
		const hours = duration.asHours();
		if (hours >= 48) {
			setPerformanceByDay(true)
		}
		let option = {};
		let xAxisArray: any = [];
		let sla_met: any = [];
		let sla_failed: any = [];
		let sla_total: any = [];

		reportData?.map((res: any, i: number) => {
			xAxisArray.push(Object.keys(res)[0])
			sla_met.push(res[xAxisArray[i]].sla_met)
			sla_total.push(res[xAxisArray[i]].sla_pending)
			sla_total.push(res[xAxisArray[i]].sla_total)
		})
		option = {
			backgroundColor: '#053367',
			grid: {
				top: '13%',
				left: '5%',
				right: '2%',
				bottom: '30%'
			},
			xAxis: {
				type: 'category',
				data: xAxisArray,
				axisLabel: {
					color: '#fff',
				}
			},
			yAxis: {
				type: 'value',
				axisLabel: {
					color: '#fff'
				}
			},
			series: [
				{
					silent: true,
					name: 'SLA Met',
					type: 'bar',
					stack: 'total',
					data: sla_met,
					itemStyle: {
						color: 'rgba(1, 192, 8, 1)'
					}
				},
				{
					silent: true,
					name: 'SLA Missed',
					type: 'bar',
					stack: 'total',
					data: sla_failed,
					itemStyle: {
						color: 'rgba(255, 162, 0, 1)'
					}
				},
				{
					silent: true,
					name: 'Scheduled',
					type: 'bar',
					stack: 'total',
					data: sla_total,
					itemStyle: {
						color: 'rgba(169, 173, 203, 1)'
					}
				}
			],
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'shadow'
				}
			},
			legend: {
				show: true,
				left: '35px',
				bottom: '15px',
				data: ['SLA Met', 'SLA Missed', 'Scheduled'],
				textStyle: {
					color: '#fff'
				}
			},
		};
		setGrafanaChartOptions(option);
		setGrafanaChartLoading(false);
	}

	const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setExecution(event.target.checked);
		fetchIncidentsDetailFunc(page, pageSize, sortingInfo, dateTimeRange[0], dateTimeRange[1], parseFilter(filterInfo), event.target.checked);
		fetchSlaReportData(dateTimeRange[0], dateTimeRange[1]);
		if (event.target.checked) {
			setToggleTitle('By Execution');
			setPerformanceTitle('Job Performance By Day')
			setExecutionTitle(`Job's Executed On ${moment.utc(dateTimeRange[0]).format('MM-DD-YYYY')}`);
		}
		else {
			setToggleTitle('By Project');
			setPerformanceTitle('Project Performance By Day')
			setExecutionTitle(`Project SLA's On ${moment.utc(dateTimeRange[0]).format('MM-DD-YYYY')}`)
		}
	};

	useEffect(() => {
		const startDate = paramsData.outageStartTime ? moment(paramsData?.outageStartTime).subtract(1, 'days') : dateTimeRange[0]
		const endDate = paramsData.outageEndTime ? moment(paramsData?.outageEndTime).add(2, 'days') : dateTimeRange[1]
		const duration = moment.duration(endDate.diff(startDate));
		const hours = duration.asHours();
		if (hours >= 48) {
			setPerformanceByDay(true)
		}
		const dateRangeList = getDatesInRange(dateTimeRange[0], dateTimeRange[1]);
		setDateRange(dateRangeList.slice(1, dateRangeList.length - 2).map(date => date.toISOString().split('T')[0]))
		fetchSlaReportData(dateTimeRange[0], dateTimeRange[1]);
	}, [])

	const seriesData = incident.includes(paramsData.assignmentGroup) || paramsData.incidentId == 'INC10974136' || paramsData.incidentId == 'INC11223786' || paramsData?.incidentId == 'INC09974786' ? [
		{ name: 'Successful', dataKey: 'successful', color: '#01C008', is3d: true, shadow: 'rgba(1, 192, 8, 0.5)' },
		{ name: 'Failure', dataKey: 'failure', color: '#cd2429', is3d: true, shadow: 'rgba(205,36,41 0.5)' },
	] : [
		{ name: 'SLA Met', dataKey: 'sla_met', color: 'rgba(1, 192, 8, 1)', is3d: true, shadow: 'rgba(1, 192, 8, 0.5)' },
		{ name: 'SLA Missed', dataKey: 'sla_missed', color: 'rgba(255, 162, 0, 1)', is3d: true, shadow: 'rgba(255, 162, 0, 0.5)' }
	];

	return (
		<Box mt="100px">
			<PageHeader
				title={[
					{
						text: 'Incident Details',
						link: '/dataestate/majorIncident'
					},
					{
						text: `Incident Impact Analysis - ${decodeURIComponent(window.location.pathname.split('/')[3])}`,
					}
				]}
				icon={IncidentIcon}>
				<CustomDropdown
					options={[
						{ label: paramsData?.configurationItem || 'TERADATA PROD', value: paramsData?.configurationItem || 'TERADATA PROD' }
					]}
					value={paramsData?.configurationItem || 'TERADATA PROD'}
					handleChange={() => { }}
				/>
				{/* [Date Range Menu] */}
				<DateRangeFilter
					fromDateTime={dateTimeRange[0]}
					toDateTime={dateTimeRange[1]}
					handleChange={handleDateTimeChange}
					handleApplyDateChange={applyDateTimeRange}
					minDateTime={minJobExecDate}
				/>
			</PageHeader>
			<Stack p={2} mt='10px' gap={2} >
				<Stack gap={2}>
					{!grafanaChartLoading ? (
						<BarChartWidget
							title={incidentType == 'teradata' ? (performanceByDay ? performanceTitle : 'Job Performance By Hour') : 'Job Performance'}
							isLoading={grafanaChartLoading}
							data={slaReport}
							seriesData={seriesData}
							handleEvent={handleSlaReportOnclick}
							isEvent={false}
							dateRange={dateRange}
						/>
					) : (
						<Loader />
					)
					}
				</Stack>
				{/* Table */}
				<Box pb={2}>
					{!loading ? (
						<CustomizedDataGrid
							title={incidentType == 'databricks' ? `Job Performance Details as on ${moment.utc(dateTimeRange[0]).format('MM-DD-YYYY')}` : `Projects Performance Details as on ${moment.utc(dateTimeRange[0]).format('MM-DD-YYYY')}`}
							tableColumns={incidentType == 'teradata' ? getColumns() : getDatabricksColumns()}
							tableData={!!incidentDetails?.length ? incidentDetails : 0}
							tableType={incidentType == 'databricks' && databrickIncident == 'Databricks' || databrickIncident == 'false' ? 'databricks' : incidentType == 'teradata' ? 'impact-teradata' : incidentType == 'databricks' && databrickIncident == 'ADB' || databrickIncident == 'R360' ? 'databricksNewInc' : 'incident'}
							defaultColumnNames={incidentType == 'teradata' ? execution ? defaultColumnNames : defaultColumnNamesProject : defaultDatabricksColumnNames}
							onSorting={handleSorting}
							currSorting={sortingInfo}
							filterDataOptions={filterData}
							searchDataValues={searchDetails}
							onFilterCheck={handleFilter}
							currFilter={filterInfo}
							onFilterSearch={handleSearch}
							page={page}
							pageSize={pageSize}
							paginationData={paginationData}
							listLength={incidentDetails && incidentDetails.length != 0 ? incidentDetails : 0}
							handlepageSizeChange={incidentType == 'teradata' ? "" : handlepageSizeChange}
							handlePageChange={incidentType == 'teradata' ? "" : handlePageChange}
							isFetching={loading}
							showExport={false}
							fileName={`Jobs.xlsx`}
							isDateRangeFilter={false}
							isDisabled={false}
							isShowMoreButton
						/>
					) : (
						<Loader />
					)}
				</Box>
			</Stack>
		</Box>
	);
};
